import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'
import type { SignatureTemplate, SignatureTemplateUpdatePayload } from './interface'

const resource = 'signatureTemplates2'

const getAll = (axios: IFactoryFunctionRequest<any, any>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/firm/${firmId}`,
  })
}

const filter = (axios: IFactoryFunctionRequest<any, any>) => ({ page = 0, search = '', limit = 20, sort = '' }: { page?: number; search?: string; limit?: number; sort?: string } = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, search, limit, ...(sort ? { sort } : {}) },
  })
}

const getOne = (axios: IFactoryFunctionRequest<SignatureTemplate, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

const create = (axios: IFactoryFunctionRequest<{ template: SignatureTemplate }, any>) => ({
  name,
  content,
  countryId,
}: {
  name: string
  content: string
  countryId?: string | null
}) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data: { name, content, ...(countryId !== undefined ? { countryId } : {}) },
  })
}

const update = (axios: IFactoryFunctionRequest<SignatureTemplate, any>) => (id: string, data: SignatureTemplateUpdatePayload) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  filter: filter(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
})
